import React from 'react'
import styles from './Tell.module.css'
import { EntryButton } from '../../../Common/CtaButton/EntryButton'
import { BackButton } from '../../../Common/CtaButton/BackButton'
import { useStepContext } from '../../../Context/StepContext'
import { useAbTestGtm } from '../../../utils/abTest'

export const Tell: React.FC<{ isSubmitting?: boolean }> = ({ isSubmitting }) => {
    const {
        updateFormData,
        formData,
        errors,
        touchField,
        touchedFields
    } = useStepContext()

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateFormData('email', e.target.value)
    }

    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateFormData('phone', e.target.value)
    }

    const handleLineIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const lineIdValue = e.target.value
        updateFormData('lineId', lineIdValue)
        if (lineIdValue.trim()) {
            updateFormData('preferLineContact', true)
        } else {
            updateFormData('preferLineContact', false)
        }
    }

    const handleAgreeTermsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateFormData('agreeTerms', e.target.checked)
    }

    const handleBlur = (field: 'email' | 'phone') => {
        touchField(field)
    }

    const showEmailError = touchedFields.email && errors.email
    const showPhoneError = touchedFields.phone && errors.phone

    const isFormValid =
        formData.email &&
        formData.phone &&
        formData.agreeTerms &&
        !errors.email &&
        !errors.phone

    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                <BackButton dataClickLabel={dataClickLabel('EF_StepForm_Step5-連絡先-戻る')} />
                <h1
                    data-view-label={dataViewLabel('EF_StepForm_Step5-連絡先')}
                    className={styles.titleText}
                >
                    Q.ご連絡先は？
                </h1>
            </div>

            <div className={styles.formContainer}>
                <div className={styles.inputField}>
                    <div className={styles.labelWrapper}>
                        <label className={styles.label}>メールアドレス</label>
                        <span className={styles.required}>必須</span>
                    </div>
                    <input
                        type='email'
                        className={`${styles.textInput} ${showEmailError ? styles.inputError : ''}`}
                        value={formData.email}
                        onChange={handleEmailChange}
                        onBlur={() => handleBlur('email')}
                        placeholder='メールアドレス'
                    />
                    {showEmailError && (
                        <div className={styles.errorMessage}>{errors.email}</div>
                    )}
                </div>

                <div className={styles.inputField}>
                    <div className={styles.labelWrapper}>
                        <label className={styles.label}>電話番号</label>
                        <span className={styles.required}>必須</span>
                    </div>
                    <input
                        type='tel'
                        className={`${styles.textInput} ${showPhoneError ? styles.inputError : ''}`}
                        value={formData.phone}
                        onChange={handlePhoneChange}
                        onBlur={() => handleBlur('phone')}
                        placeholder='電話番号'
                    />
                    {showPhoneError && (
                        <div className={styles.errorMessage}>{errors.phone}</div>
                    )}
                </div>

                <div className={styles.inputField}>
                    <div className={styles.labelWrapper}>
                        <label className={styles.label}>LINE ID</label>
                        <span className={styles.optional}>任意</span>
                    </div>
                    <input
                        type='text'
                        className={styles.textInput}
                        value={formData.lineId}
                        onChange={handleLineIdChange}
                        placeholder='LINE ID'
                    />
                </div>

                <div className={styles.checkboxContainer}>
                    <label data-click-label={dataClickLabel('EF_StepForm_Step5-連絡先-Link-利用規約')} className={styles.checkboxLabel}>
                        <input
                            type='checkbox'
                            className={styles.checkbox}
                            checked={formData.agreeTerms}
                            onChange={handleAgreeTermsChange}
                        />
                        <span className={styles.checkboxText}>
                            <span className={styles.termsLink}>
                                <a href='https://cuolega.co.jp/terms/?fpc=4901.607.365.b01e006616d8030K.1742824673000' className={styles.termsLink}>利用規約・個人情報の取り扱い</a>
                            </span>
                            （利用規約第4条、第5条）<br />に同意する
                        </span>
                    </label>
                </div>
            </div>

            <EntryButton
                disabled={!isFormValid || isSubmitting}
                isSubmitting={isSubmitting}
                dataClickLabel={dataClickLabel('EF_StepForm_Step5-連絡先-CVボタン')}
            />
        </div>
    )
}
